import { getSurveyResponses } from '../supabaseService';

/** Load survey rows for admin tab (JWT + /api/admin/survey-responses). */
export async function fetchSurveyResponses() {
  const { items, error } = await getSurveyResponses();
  if (error) throw new Error(error);
  return items;
}
